<script setup>
// 히어로 바닥의 "아래로 내려 보세요" 표시. 모니모(monimo.com)와 같은 형태다.
//
// 모니모 실측
//   40x40 상자, position:absolute, bottom:40px, 가로 가운데
//   안쪽은 Lottie 애니메이션이고 모양은 아래를 가리키는 겹화살표다.
//   우리는 Lottie 대신 CSS 로 같은 모양을 그린다 — 파일 하나 더 받을 일이 없다.
//
// 움직임 (2026-09-25 요청)
//   화살표는 하나다. 그 하나가 세 칸 거리를 미끄러져 내려간다.
//   화살표 세 개를 늦게 시작시켜 흘러내리게 했더니 세 개가 동시에 보였고,
//   하나를 steps() 로 한 칸씩 끊어 내렸더니 툭툭 끊겨 보였다. 그래서 이어서 내린다.
//
// 모니모와 다르게 둔 것
//   자리를 더 아래로 (bottom 40 → 20, HomeSceneView 쪽에 있다)
//
//   크기는 한때 모니모보다 작았다(26x14 → 20x11, 선 2.6 → 2.2). 잘 안 보인다는
//   요청으로 2026-09-30 에 모니모보다 크게 되돌렸다 — 28x15, 선 2.6.
//   viewBox 는 20x11 그대로라 28 로 그리면 선도 1.4 배가 된다. 거기에 선 자체를
//   2.2 → 2.6 으로 올려서 화면에 찍히는 굵기는 3.64px 다(전 2.2 의 1.65 배).
//
// 자리
//   히어로 캔버스에서 가운데 카드가 y 521~794 를 쓰고 그 아래는 배경뿐이라
//   바닥에 붙여도 카드와 겹치지 않는다.
//
// 움직임은 브라우저 설정과 무관하게 항상 돈다. 시세 바와 같은 이유다 —
// 어느 컴퓨터에서 봐도 같게 동작해야 한다.
defineProps({
  // 화살표 색. 히어로 배경이 어두워 기본은 히어로가 이미 쓰고 있는 금색이다.
  color: { type: String, default: '#ffc13c' },
})
</script>

<template>
  <span class="scroll-cue" aria-hidden="true" :style="{ color }">
    <span class="scroll-cue-arrow">
      <svg viewBox="0 0 20 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.6 1.9 10 9 18.4 1.9"
          stroke="currentColor"
          stroke-width="2.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
  </span>
</template>

<style scoped>
/* 칸 하나 = 화살표 높이 15 + 사이 간격 6 = 21.
   세 칸이므로 상자 높이는 15 + 21 x 2 = 57 이고, 내려가는 거리는 21 x 2 = 42 이다.
   간격도 화살표와 같은 비율(4 → 6)로 키웠다 — 간격만 두면 세 칸이 붙어 보인다. */
.scroll-cue {
  display: flex;
  width: 44px;
  height: 57px;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
}

.scroll-cue-arrow {
  display: block;
  width: 28px;
  height: 15px;
  /* 세 칸 거리를 이어서 내려간다.
     가감속을 대칭으로 둔다 — 감속만 강하면 끝에서 멈춘 듯 머물러 보인다
     (0.4,0,0.2,1 로 두니 65~90% 구간에서 27 -> 30 밖에 안 움직였다). */
  animation: scroll-cue-fall 1.5s cubic-bezier(0.45, 0, 0.55, 1) infinite;
}

.scroll-cue-arrow svg {
  display: block;
  width: 100%;
  height: 100%;
}

/* 위에서 흐리게 나타나 내려가면서 아래에서 흐려진다.
   양 끝을 지워야 되돌아가는 순간이 안 보인다 — 안 그러면 아래에서 위로
   튀어 오르는 것처럼 보인다. */
@keyframes scroll-cue-fall {
  0% {
    transform: translateY(0);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  70% {
    opacity: 1;
  }
  100% {
    transform: translateY(42px);
    opacity: 0;
  }
}
</style>
